import { Component, OnInit, Input, ViewChild } from '@angular/core';
import {NgbActiveModal, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { PlatformLocation } from '@angular/common';

import { ViewCell } from '../../../components/ng2-smart-table';

import {
	POST_WHATSAPP_MESSAGE,
	WARNING_MSG
} from "../../../../config";
import { ApiService } from '../../../services/api.service';

const ModalDismissReasons = {
	ESC: "ESC",
	BACKDROP_CLICK: "backdrop click"
};

@Component({
  selector: 'app-wa-message-action',
  templateUrl: './wa-message-action.component.html',
  styleUrls: ['./wa-message-action.component.scss']
})
export class WaMessageActionComponent implements ViewCell, OnInit {
	to: string;

	@Input() value: string | number;
	@Input() rowData: any;

	@ViewChild('replyFormPopup', {static : true} ) replyFormPopup;
	modalRef: NgbModalRef;
	closeResult: any;

	replyForm:UntypedFormGroup;

	type = '';
	msg = '';
	isAlertClose = false;

	constructor(private apiService: ApiService, private modalService: NgbModal, private location: PlatformLocation) {
		location.onPopState((event) => {
			// ensure that modal is opened
			if(this.modalRef !== undefined)
				this.modalRef.close();
		});
	}

	ngOnInit() {
	}


	setTo(value) {
		this.to = value;
	}

	openReplyPopup() {
		this.type = '';
		this.msg = '';
		this.isAlertClose = false;
		this.replyForm = new UntypedFormGroup({
			message: new UntypedFormControl('',[
				Validators.required,
			]),
			recipient: new UntypedFormControl(this.rowData.mobile)
		});

    	this.open(this.replyFormPopup);
	}

	open(content: NgbModal) {
		this.modalRef = this.modalService.open(content,{
			windowClass: "center-popup-modal",
			backdrop: "static",
		  });

		// push new state to history
		history.pushState(null, null, 'whatsapp/reports/reply');

		this.modalRef.result.then((result) => {
			this.closeResult = `Closed with: ${result}`;
		}, (reason) => {
			this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		});
	}

	private getDismissReason(reason: any): string {
		// go back in history if the modal is closed normal (ESC, backdrop click, cross click, close click)
		history.back();

		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return  `with: ${reason}`;
		}
	}

	isReply() {
		let rowdate = new Date(this.rowData.created_at);
		let current_date = new Date();
		rowdate.setHours(rowdate.getHours() + 24);
		return rowdate > current_date;
	}

	sendReply() {
		let message = this.replyForm.value.message.trim();

		if (message === '') {
			this.type = 'danger';
			this.msg = 'Message is required';
			this.isAlertClose = false;
			return;
		}

		this.type = '';
		this.msg = '';
		this.isAlertClose = false;
		this.apiService.whatapp_post(POST_WHATSAPP_MESSAGE, {'to': this.replyForm.value.recipient, 'message': message,'from':this.rowData.recipient_enc})
		.subscribe((result) => {
			console.log('sdaadadasd');
			if (result['status'] === 'success') {
				this.type = 'info';
				this.msg = result['message'];
				this.replyForm.controls['message'].reset('');
			} else {
				this.type = 'danger';
				this.msg = result['message'];
			}
		},  error => {
			this.type = 'warning';
			this.msg = WARNING_MSG;
		});
	}
}
